import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function PackageFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/apply-links/packages/options/"
  );

  return (
    <Picker
      isLoading={isLoading}
      label={t("Package")}
      items={data}
      selectedKeys={params.package_id?.split(",") || []}
      onSelectionChange={(keys) => setParam("package_id", Array.from(keys))}
      selectionMode="multiple"
      showActionBar
      testID="apply-link-package-filter"
    />
  );
}
